module.exports = __webpack_public_path__ + "static/media/zs.c5f50626.png";